import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
  ViewChild
} from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import moment from 'moment';
import {
  debounceTime,
  distinctUntilChanged,
  firstValueFrom,
  map,
  Observable,
  startWith,
  Subject,
  switchMap
} from 'rxjs';
import { MY_FORMATS } from 'src/app/helpers/datesFormat';
import { BibliaItemModel, LstServicio } from 'src/app/model/file/model.file';
import { FileService } from 'src/app/services/api/file.service';
import { FunctionsService } from 'src/app/services/api/functions.service';
import { CognitoService } from 'src/app/services/cognito.service';
import { LoadingService } from 'src/app/services/loading.service';
import { getFileDisplayState } from 'src/entities/file';
import { TimePickerDialogComponent } from 'src/widgets/detail-file-itinerary-section/time-picker-dialog/time-picker-dialog.component';
import Swal from 'sweetalert2';
import { ServicesBibliaService } from '../services/services-biblia.service';
import { BIBLIA_PROJECTION_EXPRESSIONS } from './biblia-helpers';
import { BIBLIA_ACTIONS } from './biblia.actions';
import {
  DialogEditComponent,
  DialogEditSavePayload
} from './dialog-edit/dialog-edit.component';
import { DialogRevisionACComponent } from './dialog-revisionAC/dialog-revisionAC.component';
import { DialogServiceHistorialComponent } from './dialog-service-historial/dialog-service-historial.component';
import { DialogServiciosListComponent } from './dialog-servicios-list/dialog-servicios-list.component';
import { PasajerosDialogComponent } from './pasajeros-dialog/pasajeros-dialog.component';
export interface AppState {
  biblia: number;
}

const ALLOWED_TEAM_NAMES = [
  'BOTIQUIN',
  'BIDON',
  'BALON DE OXIGENO',
  'LETREROS DE RESIDUOS',
  'TREKKING POLE',
  'DUFFLE BAG'
];

const isValidServiceCost = (service: LstServicio) =>
  service.tipoMoneda != null &&
  service.totalCostoDolares != null &&
  service.totalCostoSoles != null &&
  ((service.tipoMoneda === 'D' && service.totalCostoDolares > 0) ||
    (service.tipoMoneda === 'S' && service.totalCostoSoles > 0));

@Component({
  selector: 'app-biblia',
  templateUrl: './biblia.component.html',
  styleUrls: ['./biblia.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class BibliaComponent implements OnInit, AfterViewInit {
  fileControl = new FormControl('');
  filteredFiles$!: Observable<string[]>;

  searchFilter: string = '';

  searchValue: null | string = '';
  searchSubject: Subject<string> = new Subject<string>();
  startDate: Date | any;
  endDate: Date | any;
  startDateFile: Date | any;
  endDateFile: Date | any;

  dataFiles: any[] = [];
  dataVuelos: any[] = [];
  cantFiles: number = 0;
  contador: number = 0;
  startDateSelected: Date | any;
  endDateSelected: Date | any;

  startDateFileSelected: Date | any;
  endDateFileSelected: Date | any;

  startHourSelected: Date | any;
  endHourSelected: Date | any;

  locacionService: any;

  dataFileToUpdated: any;
  bibliaDataSource = new MatTableDataSource<BibliaItemModel>();
  isLoadingBiblia = true;
  loading: boolean = false;

  lstServices: any = [];

  bibliaDisplayedColumns: string[] = [
    'dateFile',
    'day',
    'date',
    'horaProgramada',
    'vuelos',
    'trenes',
    'fileNumber',
    'tipoSalida',
    'nombreItinerario',
    'fileDisplayState',
    'paxQuantity',
    'numero-pasajeros',
    'agencia',
    'pickUp',
    'servicio',
    'dropOff',
    'coordinador',
    'guide',
    'transport',
    'tipoUnidad',
    'driver',
    'meal',
    'snack',
    'restriccionesAlimentarias',
    'condicionesMedicas',
    'alergias',
    'observaciones',
    'tipoTarifaAlojamiento',
    'equipos',
    'destino',
    'operador',
    'usuario',
    'fechaActualizacionOperacion',
    'incidencias',
    'historial',
    'revision'
  ];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('bibliaTable') table!: MatTable<BibliaItemModel>;

  @HostListener('document:visibilitychange', ['$event'])
  onVisibilityChange() {
    if (document.visibilityState === 'visible') {
      setTimeout(() => {
        if (this.table) {
          this.table.updateStickyColumnStyles();
        }
      }, 50);
    }
  }

  private _sort!: MatSort;
  private _sortSubscription?: any;

  @ViewChild(MatSort, { static: false }) set sort(value: MatSort) {
    if (value) {
      this._sort = value;
      if (this._sortSubscription) {
        this._sortSubscription.unsubscribe();
      }
      this._sortSubscription = this._sort.sortChange.subscribe(
        (sortState: Sort) => {
          this.activeSortField = sortState.active;
          this.activeSortDirection = sortState.direction;
          this.currentPage = 0;
          if (this.paginator) {
            this.paginator.pageIndex = 0;
          }
          this.applyFilterSelect();
        }
      );
    }
  }

  get sort(): MatSort {
    return this._sort;
  }

  noShow: boolean = false;

  startDateActivity: Date | null = null;
  endDateActivity: Date | null = null;

  dataBiblia: BibliaItemModel[] = [];
  dataServices: any;
  dataFile: any;
  selectFile: null | string = null;
  selectNombreServicio: null | string = null;
  selectService: null | string = null;
  typeOfServiceSelected: null | string = null;
  selectDate: null | string = null;
  selectUser: null | string = null;
  selectProvider: null | string = null;
  selectAgencia: null | string = null;
  selectDestino = new FormControl<string[]>([]);
  selectStatus: null | string = null;
  selectReview: null | string = null;
  selectTipoSalida: null | string = null;

  nombreFileControl = new FormControl('');
  statusControl = new FormControl('');
  reviewControl = new FormControl('');
  tipoSalidaControl = new FormControl('');

  filteredNombreFiles$!: Observable<string[]>;
  filteredStatus$!: Observable<string[]>;
  filteredReviewAC$!: Observable<string[]>;
  filteredTipoSalida$!: Observable<string[]>;

  arrayFiles: string[] | null = null;
  arrayDestino: string[] | null = null;
  arrayNombreFile: string[] | null = null;
  arrayStatus: string[] | null = null;
  arrayReviewAC: string[] | null = null;
  arrayTipoSalida: string[] | null = null;

  isLegendExpanded: boolean = false;
  activePreset: 'today' | 'next3days' | 'pendingAC' | 'minors' | null = null;

  toggleLegend(): void {
    this.isLegendExpanded = !this.isLegendExpanded;
  }

  togglePreset(preset: 'today' | 'next3days' | 'pendingAC' | 'minors'): void {
    if (this.activePreset === preset) {
      this.activePreset = null;
    } else {
      this.activePreset = preset;
    }
    this.currentPage = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.applyFilterSelect();
  }

  get pendingAcCount(): number {
    return this.model
      ? this.model.filter((item: any) => item.pendingCsReviews === true).length
      : 0;
  }

  get totalActivitiesCount(): number {
    return this.model?.length || 0;
  }

  get hasActiveFilters(): boolean {
    return this.activeFilterChips.length > 0;
  }

  get activeFilterChips(): { id: string; label: string; isDb?: boolean }[] {
    const chips: { id: string; label: string; isDb?: boolean }[] = [];

    if (this.activePreset) {
      const presetLabels: Record<string, string> = {
        today: 'Hoy',
        next3days: 'Próx. 3 días',
        pendingAC: 'Pendiente A.C.',
        minors: 'Con Menores'
      };
      chips.push({
        id: 'preset',
        label: `Preset: ${presetLabels[this.activePreset] || this.activePreset}`,
        isDb: false
      });
    }

    if (this.searchValue && this.searchValue.trim()) {
      chips.push({
        id: 'search',
        label: `Búsqueda: "${this.searchValue.trim()}"`,
        isDb: false
      });
    }

    if (this.startDateActivity && this.endDateActivity) {
      chips.push({
        id: 'dateActivity',
        label: `Fecha: ${moment(this.startDateActivity).format('DD/MM/YY')} - ${moment(this.endDateActivity).format('DD/MM/YY')}`,
        isDb: true
      });
    }

    if (this.selectFile) {
      chips.push({
        id: 'file',
        label: `File: ${this.selectFile}`,
        isDb: true
      });
    }

    if (this.selectNombreServicio) {
      chips.push({
        id: 'nombreFile',
        label: `Nombre: ${this.selectNombreServicio}`,
        isDb: false
      });
    }

    const destinos = this.selectDestino?.value;
    if (Array.isArray(destinos) && destinos.length > 0) {
      destinos.forEach((d: string) => {
        chips.push({
          id: `destino_${d}`,
          label: `Destino: ${d}`,
          isDb: false
        });
      });
    }

    if (this.selectStatus) {
      chips.push({
        id: 'status',
        label: `Status: ${this.selectStatus}`,
        isDb: false
      });
    }

    if (this.selectReview) {
      chips.push({
        id: 'review',
        label: `Revisión: ${this.selectReview}`,
        isDb: false
      });
    }

    if (this.selectTipoSalida) {
      chips.push({
        id: 'tipoSalida',
        label: `Salida: ${this.selectTipoSalida}`,
        isDb: false
      });
    }

    return chips;
  }

  removeFilterChip(id: string): void {
    if (id === 'preset') {
      this.activePreset = null;
    } else if (id === 'search') {
      this.searchValue = '';
      this.searchSubject.next('');
    } else if (id === 'dateActivity') {
      this.cleanDateSelectedActivity();
      return;
    } else if (id === 'file') {
      this.fileControl.setValue('');
      this.selectFile = null;
    } else if (id === 'nombreFile') {
      this.nombreFileControl.setValue('');
      this.selectNombreServicio = null;
    } else if (id.startsWith('destino_')) {
      const dToRemove = id.replace('destino_', '');
      const current = (this.selectDestino.value || []) as string[];
      this.selectDestino.setValue(current.filter((d) => d !== dToRemove));
    } else if (id === 'status') {
      this.statusControl.setValue('');
      this.selectStatus = null;
    } else if (id === 'review') {
      this.reviewControl.setValue('');
      this.selectReview = null;
    } else if (id === 'tipoSalida') {
      this.tipoSalidaControl.setValue('');
      this.selectTipoSalida = null;
    }

    this.applyFilterSelect();
  }

  clearAllFilters(): void {
    this.activePreset = null;
    this.searchValue = '';
    this.searchSubject.next('');
    this.startDateActivity = null;
    this.endDateActivity = null;
    this.fileControl.setValue('');
    this.selectFile = null;
    this.nombreFileControl.setValue('');
    this.selectNombreServicio = null;
    this.selectDestino.setValue([]);
    this.statusControl.setValue('');
    this.selectStatus = null;
    this.reviewControl.setValue('');
    this.selectReview = null;
    this.tipoSalidaControl.setValue('');
    this.selectTipoSalida = null;
    this.currentPage = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.applyFilterSelect();
  }

  trackByChip(
    index: number,
    chip: { id: string; label: string; isDb?: boolean }
  ): string {
    return chip.id;
  }

  refreshBiblia(): void {
    this.isLoadingBiblia = true;
    this.cdRef.detectChanges();
    this.ngAfterViewInit();
  }

  arrayServices: any[] | null = null;
  arrayTypesOfService: any[] | null = null;
  arrayDates: any[] | null = null;
  arrayUsers: any[] | null = null;
  arrayProveedor: any[] | null = null;
  arrayAgencia: any[] | null = null;
  sortDirection: 'asc' | 'desc' = 'asc';
  activeSortField: string | null = null;
  activeSortDirection: 'asc' | 'desc' | '' = '';
  model: any;
  userName: string | null = null;

  startTime: any = '';
  endTime: any = '';

  value1: string | null = null;
  value2: string | null = null;
  value3: string | null = null;
  value4: string | null = null;
  value5: string | null = null;
  value6: string | null = null;
  value7: string | null = null;

  // Caches for dynamically fetched files
  allFlightsCache: any[] = [];
  allProvidersCache: any[] = [];
  allEquiposCache: any[] = [];
  filesPadresCache: any[] = [];
  arrayBibliaCache: any[] = [];
  bibliaFilesCache: any[] = [];
  fetchedFileIds = new Set<string>();
  allActivitiesAndServicesCache: any[] = [];
  allAgrupadosCache: any[] = [];

  constructor(
    private readonly fileService: FileService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly router: Router,
    public readonly loadingService: LoadingService,
    public readonly cognitoService: CognitoService,
    public dialog: MatDialog,
    public functionService: FunctionsService,
    private servicesBibliaService: ServicesBibliaService
  ) {}

  async ngOnInit() {
    this.bibliaDataSource.filterPredicate = (data: any, filter: string) => {
      return data.fileNumber?.toLowerCase().includes(filter);
    };
    this.userName = localStorage.getItem('email');

    const today = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(today.getDate() + 7);

    this.searchSubject
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(() => {
        this.applyFilterSelect();
      });

    this._initializeFileFilter();
    this._initializeAutocompleteFilters();
  }

  ngAfterViewInit() {
    this.isLoadingBiblia = true;
    this.cdRef.detectChanges();
    Promise.all([
      this.getAllFlightsPaginated(),
      this.getAllPoviders(),
      this.getFilesBiblia(),
      this.getAllgrupadoEquipo()
    ])
      .then(async (data) => {
        const resultadoGetAllFligths = data[0];
        const proveedores = data[1];
        const filesForBiblia = data[2];
        const equipos = data[3];

        const filesPadres = filesForBiblia.filter((file) => file.isSSFFPadre);

        // Filter files for initial subcall loading
        const initialMatchedFiles = filesForBiblia.filter((file) => {
          const range = this.getFileDateRange(file);
          if (!range) return false;

          const startDate = range.start.getTime();
          const endDate = range.end.getTime();

          const today = new Date();
          const todayUTC = Date.UTC(
            today.getUTCFullYear(),
            today.getUTCMonth(),
            today.getUTCDate()
          );
          const minDateUTC = todayUTC - 60 * 24 * 60 * 60 * 1000;
          const maxDateUTC = todayUTC + 30 * 24 * 60 * 60 * 1000;
          return startDate <= maxDateUTC && endDate >= minDateUTC;
        });

        // 1. Include files matching active 'Nro. de File' filter (if any)
        const activeFile = (this.selectFile || this.fileControl.value)
          ?.trim()
          ?.toLowerCase();
        if (activeFile && activeFile !== 'null') {
          const matchedByFile = filesForBiblia.filter((f) =>
            this.getFileNumberAndExtension(f).toLowerCase().includes(activeFile)
          );
          initialMatchedFiles.push(...matchedByFile);
        }

        // 2. Include files matching active Date Range filter (if any)
        if (this.startDateFile && this.endDateFile) {
          const startStr = moment(this.startDateFile).format('YYYY-MM-DD');
          const endStr = moment(this.endDateFile).format('YYYY-MM-DD');
          const matchedByDate = filesForBiblia.filter((bibliaItem) => {
            if (!bibliaItem.startDateFile) return false;
            const dateOnly = bibliaItem.startDateFile.split('T')[0];
            return dateOnly >= startStr && dateOnly <= endStr;
          });
          initialMatchedFiles.push(...matchedByDate);
        }

        // 3. Include files matching active Activity Date Range filter (if any)
        if (this.startDateActivity && this.endDateActivity) {
          const activityStart = moment(this.startDateActivity).toDate();
          activityStart.setHours(0, 0, 0, 0);
          const activityEnd = moment(this.endDateActivity).toDate();
          activityEnd.setHours(23, 59, 59, 999);

          const matchedByActDate = filesForBiblia.filter((bibliaItem) => {
            const range = this.getFileDateRange(bibliaItem);
            if (!range) return false;
            const fileStart = new Date(range.start);
            fileStart.setHours(0, 0, 0, 0);
            const fileEnd = new Date(range.end);
            fileEnd.setHours(23, 59, 59, 999);
            return fileStart <= activityEnd && fileEnd >= activityStart;
          });
          initialMatchedFiles.push(...matchedByActDate);
        }

        // 4. Include all files previously loaded/cached in this session so they are also refreshed from the server
        if (this.fetchedFileIds && this.fetchedFileIds.size > 0) {
          const previouslyLoadedFiles = filesForBiblia.filter((f) =>
            this.fetchedFileIds.has(f.id)
          );
          initialMatchedFiles.push(...previouslyLoadedFiles);
        }

        // Expand initialMatchedFiles to include related parents and children
        const initialExpandedSet = new Set<any>();
        initialMatchedFiles.forEach((file) => {
          initialExpandedSet.add(file);
          if (file.isSSFFPadre) {
            filesForBiblia.forEach((f) => {
              if (f.filePadreId === file.id) {
                initialExpandedSet.add(f);
              }
            });
          } else if (file.filePadreId) {
            const parent = filesForBiblia.find(
              (f) => f.id === file.filePadreId
            );
            if (parent) {
              initialExpandedSet.add(parent);
            }
          }
        });

        const fileIdsToLoad = [
          ...new Set(
            Array.from(initialExpandedSet)
              .map((file) => file.id)
              .filter(Boolean)
          )
        ];

        // Reset fetchedFileIds so it accurately reflects only the files currently being fetched.
        // This prevents stale IDs from blocking subsequent on-demand fetches in fetchAndAppendFilteredFiles.
        this.fetchedFileIds = new Set<string>(fileIdsToLoad);

        const activitiesServicesSSFFHijoPromises = this.handleChuncks(
          40,
          fileIdsToLoad
        ).map((chunk) => this.getServicesActivities(chunk));
        const equiposPromises = this.handleChuncks(80, [...fileIdsToLoad]).map(
          (chunk) => this.getEquipos(chunk)
        );

        const [activitiesServicesSSFFHijoChunks, allEquiposChunks] =
          await Promise.all([
            Promise.all(activitiesServicesSSFFHijoPromises),
            Promise.all(equiposPromises)
          ]);

        const serviciosYactividadesPadreEHijo =
          activitiesServicesSSFFHijoChunks.flat();
        const agrupados = allEquiposChunks.flat();

        const filesToProcess = filesForBiblia.filter((f) =>
          this.fetchedFileIds.has(f.id)
        );

        const arrayBiblia = this.agruparBiblia({
          bibliaItinerarios: filesToProcess.filter(
            (itinerary) => !itinerary?.isSSFFPadre
          ),
          arrayActivitiesAndServices: serviciosYactividadesPadreEHijo,
          agrupados,
          equipos,
          filesPadres
        });

        // Store to caches
        this.allFlightsCache = resultadoGetAllFligths;
        this.allProvidersCache = proveedores;
        this.allEquiposCache = equipos;
        this.filesPadresCache = filesPadres;
        this.bibliaFilesCache = filesForBiblia;
        this.arrayBibliaCache = arrayBiblia;
        this.allActivitiesAndServicesCache = serviciosYactividadesPadreEHijo;
        this.allAgrupadosCache = agrupados;

        this.mapFlightsAndServicesToBiblia({
          biblia: this.arrayBibliaCache,
          dataVuelos: this.allFlightsCache,
          proveedores: this.allProvidersCache
        });
      })
      .catch((error) => {
        console.error('Error al cargar datos:', error);
        this.isLoadingBiblia = false;
      })
      .finally(() => {
        this.isLoadingBiblia = false;
        setTimeout(() => {
          if (this.table) {
            this.table.updateStickyColumnStyles();
          }
          if (typeof document !== 'undefined' && 'fonts' in document) {
            document.fonts.ready.then(() => {
              if (this.table) {
                this.table.updateStickyColumnStyles();
              }
            });
          }
        }, 100);
      });
  }

  agruparBiblia({
    agrupados,
    arrayActivitiesAndServices,
    bibliaItinerarios,
    equipos,
    filesPadres
  }: {
    bibliaItinerarios: any[];
    arrayActivitiesAndServices: any[];
    agrupados: any[];
    equipos: any[];
    filesPadres: any[];
  }) {
    const bibleList: any[] = [];

    bibliaItinerarios.map(async (itineraryItem: any) => {
      const numberFilePadre: string | null = itineraryItem.filePadreId
        ? filesPadres.find((ssff: any) => ssff.id === itineraryItem.filePadreId)
            ?.fileNumber
        : null;

      let dayCusco = 1000;
      arrayActivitiesAndServices.map((activity: any) => {
        if (!activity) return;
        if (
          activity.idItinerary &&
          activity.idItinerary === itineraryItem.id &&
          this.transformUpperCase(activity.destino) == 'CUSCO' &&
          dayCusco >= activity.dayNumber
        ) {
          dayCusco = activity.dayNumber;
        }
      });
      const agrupadoSinequipoInfo =
        agrupados?.filter(
          (item: any) => item.itineraryId === itineraryItem.id
        ) ?? [];

      let lstEquipos: any[] = agrupadoSinequipoInfo.map((agrupado: any) => {
        agrupado.agrupadoInfo = equipos.find(
          (equipo: any) => equipo.id === agrupado.agrupadoId
        );
        return agrupado;
      });

      if (itineraryItem.lstPaX?.length && lstEquipos?.length) {
        const paxSize = itineraryItem?.lstPaX?.length;
        const uniqueIdEquipos = new Set();

        const filteredData = lstEquipos?.filter((item: any) => {
          if (!item.agrupadoInfo) return false;

          if (uniqueIdEquipos.has(item.agrupadoInfo.equipoId)) {
            return false;
          }

          uniqueIdEquipos.add(item.agrupadoInfo.equipoId);
          return true;
        });

        const filterCantPax = filteredData.filter(
          (item: any) =>
            item.agrupadoInfo &&
            item.agrupadoInfo.nroPersonasPax?.[paxSize - 1] !== '' &&
            ALLOWED_TEAM_NAMES.includes(item.agrupadoInfo.nombreEquipo)
        );

        filterCantPax.sort((a: any, b: any) =>
          a.agrupadoInfo.nombreEquipo.localeCompare(b.agrupadoInfo.nombreEquipo)
        );

        lstEquipos = filterCantPax.map(
          (item: any) => item.agrupadoInfo.nombreEquipo
        );
      }

      const dateTemp = itineraryItem?.dateRange?.split(' ');
      const fechaTemp = dateTemp?.[0]?.split('/');
      const fileNumber = itineraryItem?.fileNumber;
      const fileExtend = itineraryItem?.fileExtend;
      const diasItinerario = itineraryItem?.diasItinerario;

      const dateRange = itineraryItem?.dateRange;
      const nombreItinerario = itineraryItem?.nombreItinerario;
      const fileDisplayState = getFileDisplayState({
        estadoFile: itineraryItem?.estadoFile,
        estadoItinerario: itineraryItem?.estadoItinerario,
        lastMinute: itineraryItem?.lastMinute,
        pendingPreOpIncidents: itineraryItem?.pendingPreOpIncidents
      });
      const usuario = itineraryItem?.usuario;
      const lstPaX = itineraryItem?.lstPaX ?? [];
      const idItinerary = itineraryItem?.id;
      const agencia = itineraryItem?.nameClient;
      const equipo = lstEquipos ?? [];
      const fileNumberPadre = numberFilePadre ?? null;

      let ssffActivitiesWithServices = null as any;

      if (fileNumberPadre) {
        ssffActivitiesWithServices = arrayActivitiesAndServices.filter(
          (activity: any) => activity?.idItinerary === itineraryItem.filePadreId
        );
      }

      arrayActivitiesAndServices
        .filter(
          (activityWithServices: any) =>
            activityWithServices?.idItinerary === itineraryItem.id
        )
        .forEach(async (activityWithServices: any) => {
          const initialFileDate = new Date(
            `${fechaTemp[1]}/${fechaTemp[0]}/${fechaTemp[2]}`
          );

          const initialActivityDate = new Date(
            `${fechaTemp[1]}/${fechaTemp[0]}/${fechaTemp[2]}`
          );

          initialActivityDate.setDate(
            initialActivityDate.getDate() + activityWithServices.dayNumber - 1
          );
          let ssffActivity = null;
          if (
            ssffActivitiesWithServices != null &&
            itineraryItem?.filePadreId &&
            activityWithServices.tipoSalida === 'Salida Fija'
          ) {
            ssffActivity = ssffActivitiesWithServices.find(
              (ssffActivityWithServices: any) =>
                itineraryItem.filePadreId ===
                  ssffActivityWithServices.idItinerary &&
                activityWithServices.dayInProduct ===
                  ssffActivityWithServices.dayInProduct
            );
          }

          const currentLstPaXByActivity = activityWithServices?.lstPaX.filter(
            (pax: any) => !!pax?.estado
          );

          const newBibliaItem: any = {
            dayName: activityWithServices.dayName,
            dayInItinerary: activityWithServices.dayInItinerary,
            lstServiciosSSFF: ssffActivity?.services ?? null,
            usuario,
            paxCount:
              activityWithServices?.lstPaX?.filter((pax: any) =>
                pax.Pax.includes('passenger-')
              ).length || 0,
            tcCount:
              activityWithServices?.lstPaX?.filter((pax: any) =>
                pax.Pax.includes('tc-')
              ).length || 0,
            lstPaXByActivity: currentLstPaXByActivity,
            itineraryLstPaX: lstPaX,
            tipoSalida: activityWithServices.tipoSalida,
            isSSFFActivity: ssffActivity ? true : false,
            fileDisplayState: fileDisplayState,
            idItinerary,
            obsActivity: activityWithServices.observaciones,
            equipo: activityWithServices.dayNumber === dayCusco ? equipo : [],
            fileNumberPadre,
            filePadreId: itineraryItem.filePadreId ?? null,
            pendingCsReviews: activityWithServices.pendingCsReviews,
            day: activityWithServices.dayNumber,
            pickUp: activityWithServices.pickUp,
            dropOff: activityWithServices.dropOff,
            driver: activityWithServices.driver,
            dateActualizacion: activityWithServices.dateActualizacion,
            usuarioOperador: activityWithServices.usuarioOperador,
            destino: activityWithServices?.dayDestino
              ? activityWithServices?.dayDestino
              : activityWithServices.destino,
            horaInicioOperacion: activityWithServices.horaInicioOperacion,
            horaProgramada: activityWithServices.horaProgramada,
            idActivity: activityWithServices.id,
            dateFile: initialFileDate.toISOString(),
            dateBiblia: initialActivityDate.toISOString(),
            date: this._getDateTransformDate(initialActivityDate.toISOString()),
            fileNumber,
            fileExtend,
            diasItinerario,
            dateRange,
            startDateFile: itineraryItem?.startDateFile,
            agencia,
            nombreItinerario,
            vuelos: [],
            lstServicios: activityWithServices.services
          };
          bibleList.push(newBibliaItem);
        });
    });
    return bibleList;
  }

  private _initializeFileFilter() {
    this.filteredFiles$ = this.fileControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        if (!value) {
          this.selectFile = null;
          this.applyFilterSelect();
        }
        return this._filterFiles(value || '');
      })
    );
  }

  private _filterFiles(value: string): string[] {
    if (!this.arrayFiles || this.arrayFiles?.length === 0) {
      return [];
    }

    const filterValue = value.toLowerCase();
    return this.arrayFiles.filter(
      (file) =>
        file &&
        typeof file === 'string' &&
        file.toLowerCase().includes(filterValue)
    );
  }

  private _initializeAutocompleteFilters() {
    this.filteredNombreFiles$ = this.nombreFileControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        if (!value) {
          this.selectNombreServicio = null;
          this.applyFilterSelect();
        }
        return this._filterArray(value || '', this.arrayNombreFile);
      })
    );
    this.filteredStatus$ = this.statusControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        if (!value) {
          this.selectStatus = null;
          this.applyFilterSelect();
        }
        return this._filterArray(value || '', this.arrayStatus);
      })
    );
    this.filteredReviewAC$ = this.reviewControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        if (!value) {
          this.selectReview = null;
          this.applyFilterSelect();
        }
        return this._filterArray(value || '', this.arrayReviewAC);
      })
    );
    this.filteredTipoSalida$ = this.tipoSalidaControl.valueChanges.pipe(
      startWith(''),
      map((value) => {
        if (!value) {
          this.selectTipoSalida = null;
          this.applyFilterSelect();
        }
        return this._filterArray(value || '', this.arrayTipoSalida);
      })
    );
  }

  private _filterArray(value: string, array: string[] | null): string[] {
    if (!array || array.length === 0) return [];
    const filterValue = value.toLowerCase();
    return array.filter(
      (item) =>
        item &&
        typeof item === 'string' &&
        item.toLowerCase().includes(filterValue)
    );
  }

  onNombreFileSelected(selected: string) {
    this.selectNombreServicio = selected === 'null' ? null : selected;
    this.applyFilterSelect();
  }

  onStatusSelected(selected: string) {
    this.selectStatus = selected === 'null' ? null : selected;
    this.applyFilterSelect();
  }

  onReviewSelected(selected: string) {
    this.selectReview = selected === 'null' ? null : selected;
    this.applyFilterSelect();
  }

  onTipoSalidaSelected(selected: string) {
    this.selectTipoSalida = selected === 'null' ? null : selected;
    this.applyFilterSelect();
  }

  private getFileNumberAndExtension(file: any): string {
    return `${file?.fileNumber || ''}${file?.fileExtend || ''}`.trim();
  }

  async onFileSelected(selectedFile: string | null) {
    if (!selectedFile || selectedFile === 'null') {
      this.selectFile = null;
      this.fileControl.setValue('', { emitEvent: false });
      this.applyFilterSelect();
      return;
    }
    const trimmed = selectedFile.trim();
    this.selectFile = trimmed;
    await this.fetchAndAppendFilteredFiles({ fileNumber: trimmed });
    this.applyFilterSelect();
  }

  async onFileFilterEnter() {
    const value = this.fileControl.value?.trim();
    if (value && value !== 'null') {
      this.selectFile = value;
      await this.fetchAndAppendFilteredFiles({ fileNumber: value });
      this.applyFilterSelect();
    } else {
      this.selectFile = null;
      this.applyFilterSelect();
    }
  }

  /**
   * Applies the selected date range filter.
   * Formats the start and end dates to 'YYYY-MM-DD' strings and fetches
   * files that fall within this range to ensure timezone shifts are avoided.
   * After fetching, it updates the filtered view.
   * @returns {Promise<void>}
   */
  async onDateFilterApply() {
    if (this.startDateFile && this.endDateFile) {
      const start = moment(this.startDateFile).format('YYYY-MM-DD');
      const end = moment(this.endDateFile).format('YYYY-MM-DD');
      await this.fetchAndAppendFilteredFiles({
        startDate: start,
        endDate: end
      });
    }
    this.applyFilterSelect();
  }

  async onActivityDateFilterApply() {
    if (this.startDateActivity && !this.endDateActivity) {
      this.endDateActivity = this.startDateActivity;
    }
    if (this.startDateActivity && this.endDateActivity) {
      await this.fetchAndAppendFilteredFiles({
        startActivityDate: this.startDateActivity,
        endActivityDate: this.endDateActivity
      });
    }
    this.applyFilterSelect();
  }

  getFileDateRange(file: any): { start: Date; end: Date } | null {
    let start: Date | null = null;
    let end: Date | null = null;

    if (file.dateRange && typeof file.dateRange === 'string') {
      const parts = file.dateRange.split('-').map((s: string) => s.trim());
      if (parts.length === 2) {
        const startParts = parts[0].split('/');
        const endParts = parts[1].split('/');
        if (startParts.length === 3 && endParts.length === 3) {
          const startDay = parseInt(startParts[0], 10);
          const startMonth = parseInt(startParts[1], 10);
          const startYear = parseInt(startParts[2], 10);
          start = new Date(startYear, startMonth - 1, startDay);

          const endDay = parseInt(endParts[0], 10);
          const endMonth = parseInt(endParts[1], 10);
          const endYear = parseInt(endParts[2], 10);
          end = new Date(endYear, endMonth - 1, endDay);
        }
      }
    }

    if (!start || isNaN(start.getTime())) {
      if (file.startDateFile) {
        if (typeof file.startDateFile === 'string') {
          const parts = file.startDateFile.split('T')[0].split('-');
          if (parts.length === 3) {
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10);
            const day = parseInt(parts[2], 10);
            start = new Date(year, month - 1, day);
          }
        } else {
          start = new Date(file.startDateFile);
        }
      }
    }

    if (!start || isNaN(start.getTime())) {
      return null;
    }

    if (!end || isNaN(end.getTime())) {
      end = new Date(start);
      const days = file.diasItinerario ? Number(file.diasItinerario) : 1;
      end.setDate(end.getDate() + days - 1);
    }

    return { start, end };
  }

  /**
   * Fetches missing files based on the applied filters (file number or date range)
   * and appends them to the internal data caches.
   * Uses string-based date comparisons (YYYY-MM-DD) to prevent timezone bugs.
   *
   * @param filters - An object containing filtering criteria.
   * @param {string} [filters.startDate] - Start date string in 'YYYY-MM-DD' format.
   * @param {string} [filters.endDate] - End date string in 'YYYY-MM-DD' format.
   * @param {string} [filters.fileNumber] - Specific file number string to filter by.
   * @param {Date} [filters.startActivityDate] - Start date of selected activities.
   * @param {Date} [filters.endActivityDate] - End date of selected activities.
   * @returns {Promise<void>}
   */
  async fetchAndAppendFilteredFiles(filters: {
    startDate?: string;
    endDate?: string;
    fileNumber?: string;
    startActivityDate?: Date;
    endActivityDate?: Date;
  }) {
    try {
      this.loading = true;
      this.cdRef.detectChanges();

      let matchedFiles: any[] = [];

      if (filters.fileNumber) {
        const fileNumberStr = filters.fileNumber.toLowerCase();
        matchedFiles = this.bibliaFilesCache.filter((f) =>
          this.getFileNumberAndExtension(f)
            .toLowerCase()
            .includes(fileNumberStr)
        );
      } else if (filters.startDate && filters.endDate) {
        matchedFiles = this.bibliaFilesCache.filter((bibliaItem) => {
          if (!bibliaItem.startDateFile) return false;

          // Compare raw YYYY-MM-DD strings directly to prevent timezone shift issues.
          const dateOnly = bibliaItem.startDateFile.split('T')[0];
          return dateOnly >= filters.startDate! && dateOnly <= filters.endDate!;
        });
      } else if (filters.startActivityDate && filters.endActivityDate) {
        const activityStart = moment(filters.startActivityDate).toDate();
        activityStart.setHours(0, 0, 0, 0);

        const activityEnd = moment(filters.endActivityDate).toDate();
        activityEnd.setHours(23, 59, 59, 999);

        matchedFiles = this.bibliaFilesCache.filter((bibliaItem) => {
          const range = this.getFileDateRange(bibliaItem);
          if (!range) return false;

          const fileStart = new Date(range.start);
          fileStart.setHours(0, 0, 0, 0);

          const fileEnd = new Date(range.end);
          fileEnd.setHours(23, 59, 59, 999);

          return fileStart <= activityEnd && fileEnd >= activityStart;
        });
      }

      // Expand matchedFiles to include related parent and child files to ensure complete data sets are fetched
      const expandedFilesSet = new Set<any>();
      matchedFiles.forEach((matchedFile) => {
        expandedFilesSet.add(matchedFile);
        if (matchedFile.isSSFFPadre) {
          // Find all child files of this parent
          this.bibliaFilesCache.forEach((cachedFile) => {
            if (cachedFile.filePadreId === matchedFile.id) {
              expandedFilesSet.add(cachedFile);
            }
          });
        } else if (matchedFile.filePadreId) {
          // Find parent file of this child
          const parent = this.bibliaFilesCache.find(
            (cachedFile) => cachedFile.id === matchedFile.filePadreId
          );
          if (parent) {
            expandedFilesSet.add(parent);
          }
        }
      });
      matchedFiles = Array.from(expandedFilesSet);

      console.log('Matched Files:', matchedFiles.length, matchedFiles);

      const filesToProcess = matchedFiles.filter(
        (matchedFile: any) =>
          matchedFile.id && !this.fetchedFileIds.has(matchedFile.id)
      );

      console.log('Files to Process:', filesToProcess.length, filesToProcess);

      if (!filesToProcess.length) {
        this.loading = false;
        return;
      }

      const fileIds = filesToProcess.map(
        (fileToProcess: any) => fileToProcess.id
      );

      const activitiesServicesPromises = this.handleChuncks(40, fileIds).map(
        (chunk) => this.getServicesActivities(chunk)
      );
      const equiposPromises = this.handleChuncks(80, [...fileIds]).map(
        (chunk) => this.getEquipos(chunk)
      );

      const [activitiesServicesChunks, equiposChunks] = await Promise.all([
        Promise.all(activitiesServicesPromises),
        Promise.all(equiposPromises)
      ]);

      const serviciosYactividades = activitiesServicesChunks.flat();
      const agrupados = equiposChunks.flat();

      fileIds.forEach((id: string) => this.fetchedFileIds.add(id));

      this.allActivitiesAndServicesCache = [
        ...this.allActivitiesAndServicesCache,
        ...serviciosYactividades
      ];
      this.allAgrupadosCache = [...this.allAgrupadosCache, ...agrupados];

      const fetchedItineraries = this.bibliaFilesCache.filter((f) =>
        this.fetchedFileIds.has(f.id)
      );

      this.arrayBibliaCache = this.agruparBiblia({
        bibliaItinerarios: fetchedItineraries.filter(
          (itinerary: any) => !itinerary?.isSSFFPadre
        ),
        arrayActivitiesAndServices: this.allActivitiesAndServicesCache,
        agrupados: this.allAgrupadosCache,
        equipos: this.allEquiposCache,
        filesPadres: this.filesPadresCache
      });

      this.mapFlightsAndServicesToBiblia({
        biblia: this.arrayBibliaCache,
        dataVuelos: this.allFlightsCache,
        proveedores: this.allProvidersCache
      });
    } catch (error) {
      console.error('Error fetching filtered files:', error);
    } finally {
      this.loading = false;
      this.cdRef.detectChanges();
    }
  }

  getOptionText(file: string): string {
    return file || '';
  }

  onSearchChange(searchValue: string) {
    this.searchValue = searchValue;
    this.searchSubject.next(searchValue);
  }

  async getAllgrupadoEquipo() {
    try {
      const data = await firstValueFrom(
        this.fileService.queryGetAllgrupadoEquipo()
      );
      return data.getAllgrupadoEquipo ?? [];
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async getAllPoviders() {
    try {
      const data: any = await firstValueFrom(
        this.fileService.getAllProvidersWithProjectionExpression()
      );

      return data.getAllProvidersWithProjectionExpression ?? [];
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async getServicesActivities(itineariesId: string[]) {
    try {
      const chunks = this.handleChuncks(35, itineariesId);
      const allServicesActivitiesChunks: any[] = [];

      for (const chunk of chunks) {
        const servicesAndActivitiesResponse: any = await firstValueFrom(
          this.fileService.queryServicesAndActivities({
            itinearyIds: chunk
          })
        );

        allServicesActivitiesChunks.push(
          servicesAndActivitiesResponse.ServicesAndActivities
        );
      }

      return allServicesActivitiesChunks.flat();
    } catch (error: any) {
      console.log('error getServicesActivities');
      throw new Error(error);
    }
  }

  async getItineraryByIds(itineariesId: string[]) {
    try {
      const data: any = await firstValueFrom(
        this.fileService.getItineraryByIds({
          ids: itineariesId,
          projectionExpression:
            BIBLIA_PROJECTION_EXPRESSIONS.itineraries.join(',')
        })
      );

      return data.getItineraryByIds;
    } catch (error: any) {
      console.log('error getItineraryByIds');
      throw new Error(error);
    }
  }

  async getEquipos(itineariesId: string[]) {
    try {
      const data = await firstValueFrom(
        this.fileService.queryEquiposByitinearyIds({
          itinearyIds: itineariesId
        })
      );

      return data.EquiposByitinearyIds;
    } catch (error: any) {
      console.log('error getEquipos');
      throw new Error(error);
    }
  }

  async getAllFlightsPaginated() {
    try {
      let lastEvaluatedKeyId = null;
      let allFlights: any[] = [];
      do {
        const getAllFlightsPaginatedResponse: {
          getAllFlightsPaginated: {
            lstFlight: any[];
            LastEvaluatedKey: string | null;
          };
        } = await firstValueFrom(
          this.fileService.queryGetAllFlightsPaginated({
            projectionExpression:
              BIBLIA_PROJECTION_EXPRESSIONS.flights.join(','),
            exclusiveStartKeyId: lastEvaluatedKeyId
          })
        );
        const lstFlight =
          getAllFlightsPaginatedResponse?.getAllFlightsPaginated?.lstFlight;
        lastEvaluatedKeyId =
          getAllFlightsPaginatedResponse?.getAllFlightsPaginated
            ?.LastEvaluatedKey;
        allFlights = allFlights.concat(lstFlight);
      } while (lastEvaluatedKeyId);

      return allFlights;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  async getFilesBiblia() {
    try {
      let LastEvaluatedKey = null;
      let hasMore = true;
      let restBibliaFiles: any[];
      let response: any;
      let bibliaFiles: any[] = [];
      while (hasMore) {
        response = await firstValueFrom(
          this.fileService.queryGetFilesBiblia({
            key: LastEvaluatedKey,
            projectionExpression: BIBLIA_PROJECTION_EXPRESSIONS.files.join(',')
          })
        );

        hasMore = response?.getFilesPadresEHijosBiblia?.isThereMore;
        restBibliaFiles = response?.getFilesPadresEHijosBiblia?.resultFiles;
        bibliaFiles = [...bibliaFiles, ...restBibliaFiles];
        LastEvaluatedKey =
          response?.getFilesPadresEHijosBiblia?.LastEvaluatedKey;
      }

      return bibliaFiles;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  handleChuncks(numberChunks: number, lista: any[]) {
    const chunks = [];
    for (let i = 0; i < lista.length; i += numberChunks) {
      chunks.push(lista.slice(i, i + numberChunks));
    }
    return chunks;
  }
  getDate() {
    const currentDate = new Date();
    const startDate = new Date(currentDate);
    const endDate = new Date(currentDate.setDate(currentDate.getDate() + 7));
    const startDateFormatted = `${startDate.getDate()}/${
      startDate.getMonth() + 1
    }/${startDate.getFullYear()}`;
    const endDateFormatted = `${endDate.getDate()}/${
      endDate.getMonth() + 1
    }/${endDate.getFullYear()}`;
    return `${startDateFormatted} - ${endDateFormatted}`;
  }

  getDateRange1(dateRange: string) {
    const [range1Str, _] = dateRange.split('-').map((s) => s.trim());
    const [day, month, year] = range1Str
      .split('/')
      .map((num) => parseInt(num, 10));

    return new Date(year, month - 1, day);
  }

  getDateRange2(dateRange: string, diasItinerario: number) {
    const dateInitial = this.getDateRange1(dateRange);

    const dateFinal = new Date(dateInitial);
    dateFinal.setDate(dateFinal.getDate() + diasItinerario);

    return dateFinal;
  }

  isFlightVisible(row: any, vuelo: any): boolean {
    const flightDate = new Date(vuelo.flightDate);
    const fechaStr = row.date;
    const partes = fechaStr.split('-');
    const rowDate = new Date(
      `${partes[2]}-${partes[1]}-${partes[0]}T00:00:00-05:00`
    );
    const range1 = this.getDateRange1(row.dateRange);
    const range2 = this.getDateRange2(row.dateRange, row.diasItinerario);
    const formatDate = (date: Date) => date.toISOString().split('T')[0];
    return (
      formatDate(flightDate) === formatDate(rowDate) ||
      (formatDate(flightDate) < formatDate(range1) &&
        formatDate(rowDate) === formatDate(range1)) ||
      (formatDate(flightDate) > formatDate(range2) &&
        formatDate(rowDate) === formatDate(range2))
    );
  }

  toggleSortDirection() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.applyFilterSelect(); // llama nuevamente al sort
  }

  isFlightVisibleValidate(bibliaItem: BibliaItemModel): boolean {
    if (
      !bibliaItem.vuelos ||
      bibliaItem.vuelos?.length === 0 ||
      !bibliaItem.date
    ) {
      return false;
    }

    const partes = bibliaItem.date.split('-');

    const rowDate = new Date(
      `${partes[2]}-${partes[1]}-${partes[0]}T00:00:00-05:00`
    );
    if (isNaN(rowDate.getTime())) {
      return false;
    }

    const range1 = this.getDateRange1(bibliaItem.dateRange);
    const range2 = this.getDateRange2(
      bibliaItem.dateRange,
      bibliaItem.diasItinerario
    );

    const formatDate = (date: Date) => {
      if (!date || isNaN(date.getTime())) return null;
      return date.toISOString().split('T')[0];
    };

    const formattedRowDate = formatDate(rowDate);
    const formattedRange1 = formatDate(range1);
    const formattedRange2 = formatDate(range2);

    if (!formattedRowDate || !formattedRange1 || !formattedRange2) {
      return false;
    }

    return bibliaItem.vuelos.some((vuelo: any) => {
      const flightDate = new Date(vuelo.flightDate);
      const formattedFlightDate = formatDate(flightDate);
      if (!formattedFlightDate) return false;

      return (
        formattedFlightDate === formattedRowDate ||
        (formattedFlightDate < formattedRange1 &&
          formattedRowDate === formattedRange1) ||
        (formattedFlightDate > formattedRange2 &&
          formattedRowDate === formattedRange2)
      );
    });
  }

  private _compareDayInItinerary(a: any, b: any): number {
    const valA = a ? String(a).trim() : '';
    const valB = b ? String(b).trim() : '';

    if (!valA && !valB) return 0;
    if (!valA) return 1;
    if (!valB) return -1;

    const partsA = valA.split('-').map(Number);
    const partsB = valB.split('-').map(Number);

    const majorA = isNaN(partsA[0]) ? 0 : partsA[0];
    const majorB = isNaN(partsB[0]) ? 0 : partsB[0];

    if (majorA !== majorB) {
      return majorA - majorB;
    }

    const minorA = partsA.length > 1 && !isNaN(partsA[1]) ? partsA[1] : 0;
    const minorB = partsB.length > 1 && !isNaN(partsB[1]) ? partsB[1] : 0;

    return minorA - minorB;
  }

  private _compareHoraProgramada(horaA: any, horaB: any): number {
    if (!horaA && !horaB) return 0;
    if (!horaA) return 1;
    if (!horaB) return -1;

    const [hA, mA, sA] = String(horaA).split(':').map(Number);
    const [hB, mB, sB] = String(horaB).split(':').map(Number);

    const totalSecondsA =
      (isNaN(hA) ? 0 : hA) * 3600 +
      (isNaN(mA) ? 0 : mA) * 60 +
      (isNaN(sA) ? 0 : sA);
    const totalSecondsB =
      (isNaN(hB) ? 0 : hB) * 3600 +
      (isNaN(mB) ? 0 : mB) * 60 +
      (isNaN(sB) ? 0 : sB);

    return totalSecondsA - totalSecondsB;
  }

  private _defaultBibliaSort(bibliaItemA: any, bibliaItemB: any): number {
    const dateA = this._parseDateDDMMYYYY(bibliaItemA.date);
    const dateB = this._parseDateDDMMYYYY(bibliaItemB.date);

    if (dateA !== dateB) {
      return dateA - dateB;
    }

    const fileA = `${bibliaItemA.fileNumber || ''}${bibliaItemA.fileExtend || ''}`;
    const fileB = `${bibliaItemB.fileNumber || ''}${bibliaItemB.fileExtend || ''}`;

    if (fileA !== fileB) {
      return fileA.localeCompare(fileB);
    }

    const horaA = bibliaItemA.horaProgramada;
    const horaB = bibliaItemB.horaProgramada;
    let cmpHora = 0;
    if (horaA && horaB) {
      cmpHora = this._compareHoraProgramada(horaA, horaB);
    } else if (horaA) {
      cmpHora = -1;
    } else if (horaB) {
      cmpHora = 1;
    }

    if (cmpHora !== 0) {
      return cmpHora;
    }

    return this._compareDayInItinerary(
      bibliaItemA.dayInItinerary,
      bibliaItemB.dayInItinerary
    );
  }

  mapFlightsAndServicesToBiblia({
    biblia,
    dataVuelos,
    proveedores
  }: {
    biblia: any[];
    dataVuelos: any[];
    proveedores: any[];
  }) {
    const vueloMap = new Map<string, any[]>();
    const proveedorMap = new Map(proveedores.map((p) => [p.id, p]));

    for (const vuelo of dataVuelos) {
      if (!vuelo?.itineraryId) continue;
      if (!vueloMap.has(vuelo?.itineraryId)) {
        vueloMap.set(vuelo?.itineraryId, []);
      }
      vueloMap.get(vuelo?.itineraryId)?.push(vuelo);
    }

    const typesServices: string[] = [];
    const typesProviders: string[] = [];
    const sortedBiblia = biblia
      .sort((bibliaItemA: any, bibliaItemB: any) =>
        this._defaultBibliaSort(bibliaItemA, bibliaItemB)
      )
      .map((bibliaItem: BibliaItemModel) => {
        const idItinerary = bibliaItem.idItinerary;

        const vuelos = idItinerary
          ? vueloMap.get(idItinerary)?.filter((vuelo) => {
              const paxFlightIds = (bibliaItem.lstPaXByActivity || [])
                .map((pax) => pax.flightIds)
                .flat()
                .filter(Boolean);

              return paxFlightIds.includes(vuelo.id);
            }) || []
          : [];

        [
          ...(bibliaItem.lstServicios || []),
          ...(bibliaItem.lstServiciosSSFF || [])
        ].forEach((service: any) => {
          service.objProvider = service.providerId
            ? proveedorMap.get(service.providerId)
            : null;
        });

        const validBibliaItemServices = (bibliaItem.lstServicios || []).filter(
          (service) => isValidServiceCost(service)
        );

        const validBibliaItemSsffServices = (
          bibliaItem.lstServiciosSSFF || []
        ).filter((service) => isValidServiceCost(service));

        const ssffOrRegular =
          validBibliaItemSsffServices.length > 0
            ? validBibliaItemSsffServices
            : validBibliaItemServices;

        validBibliaItemServices.forEach((s: any) => {
          if (s.tipoServicio) typesServices.push(s.tipoServicio);
          if (s.objProvider?.nombre) typesProviders.push(s.objProvider.nombre);
        });

        // Validar const para ver si de la lista de servicios hay algun servicio upgrade en tipoServicio -> TICKET, ALIMENTOSYBEBIDAS, ALOJAMIENTO.
        // si uno de estos servicios no tiene productId se considera upgrade, si tiene productId se considera normal.

        const upgradeServiceTypes = validBibliaItemServices
          .filter(
            (service: any) =>
              (service.tipoServicio === 'TICKET' ||
                service.tipoServicio === 'ALIMENTOSYBEBIDAS' ||
                service.tipoServicio === 'ALOJAMIENTO') &&
              !service.productId &&
              !service.serviceAdd &&
              service.ssffproduct
          )
          .map((service: any) => service.tipoServicio);

        const serviciosGuia = ssffOrRegular.filter(
          (service: any) => service.tipoServicio === 'GUIA'
        );

        const serviciosOperador = ssffOrRegular.filter(
          (service: any) => service.tipoServicio === 'OPERADOR'
        );

        const serviciosTransporte = ssffOrRegular.filter(
          (service: any) =>
            service.tipoServicio === 'TRANSPORTE' &&
            service.categoriaServicio !== 'TREN'
        );

        const serviciosMeals = ssffOrRegular.filter(
          (service: any) =>
            service.tipoServicio === 'ALIMENTOSYBEBIDAS' &&
            !service.nombreServicio?.toLowerCase().includes('snack') &&
            !service.nombreServicio?.toLowerCase().includes('bidon de agua')
        );

        return {
          ...bibliaItem,
          vuelos,
          lstServicios: validBibliaItemServices,
          expanded: false,
          dateFileStr: this._getDateTransformDate(bibliaItem.dateFile || ''),
          upgradeServiceTypes: upgradeServiceTypes,
          hasUpgradeService: upgradeServiceTypes.length > 0,
          servicios: validBibliaItemServices.filter(
            (service: any) =>
              !['COORDINADOR', 'GUIA', 'TRANSPORTE'].includes(
                service.tipoServicio
              )
          ),
          serviciosCoordinador: validBibliaItemServices.filter(
            (service: any) => service.tipoServicio === 'COORDINADOR'
          ),
          serviciosAlojamiento: validBibliaItemServices.filter(
            (service: any) => service.tipoServicio === 'ALOJAMIENTO'
          ),
          serviciosOperador: validBibliaItemServices.filter(
            (service: any) => service.tipoServicio === 'OPERADOR'
          ),
          serviciosGuia:
            // Regla de negocio para Productos Tercerizados, si no hay GUIAS, mostrar OPERADOR (es tercerizado)
            serviciosGuia.length > 0 ? serviciosGuia : serviciosOperador,
          serviciosTransporte: serviciosTransporte,
          serviciosMeals: serviciosMeals,

          serviciosMedio: validBibliaItemServices.filter(
            (service: any) =>
              service.tipoServicio === 'TICKET' &&
              service.categoriaServicio === 'TREN'
          ),
          serviciosSnacks: validBibliaItemServices.filter(
            (service: any) =>
              service.tipoServicio === 'ALIMENTOSYBEBIDAS' &&
              service.nombreServicio?.toLowerCase().includes('snack')
          )
        };
      });

    const uniqueBy = (arr: any[], prop: string) => [
      ...new Set(
        arr
          .map((item: any) => item[prop])
          .filter(Boolean)
          .sort((a: any, b: any) => {
            if (typeof a === 'string' && typeof b === 'string') {
              return a.localeCompare(b);
            }
            if (typeof a === 'number' && typeof b === 'number') {
              return a - b;
            }
            return String(a).localeCompare(String(b));
          })
      )
    ];

    const getAllFilesForSearch = ({ biblia }: { biblia: any[] }) => [
      ...new Set(
        biblia
          .map((bibliaItem: any) => this.getFileNumberAndExtension(bibliaItem))
          .filter(Boolean)
          .sort((a: any, b: any) => b.localeCompare(a))
      )
    ];

    this.dataFiles = sortedBiblia;
    this.cantFiles = uniqueBy(sortedBiblia, 'idItinerary')?.length;
    this.model = sortedBiblia;

    // Log activities per file
    // const fileActivityCounts = new Map<string, number>();
    // sortedBiblia.forEach((item: any) => {
    //   const key = item.idItinerary || item.fileNumber || 'unknown';
    //   fileActivityCounts.set(key, (fileActivityCounts.get(key) || 0) + 1);
    // });
    // console.log(`[mapFlightsAndServicesToBiblia] Activities per file (${fileActivityCounts.size} files, ${sortedBiblia.length} total items):`);
    // fileActivityCounts.forEach((count, fileId) => {
    //   console.log(`  File ${fileId}: ${count} activities`);
    // });

    this.arrayFiles = getAllFilesForSearch({ biblia: this.bibliaFilesCache });
    this.arrayDestino = [
      ...new Set(
        sortedBiblia
          .map((item) => item?.destino?.toUpperCase())
          .filter(Boolean)
          .sort((a: any, b: any) => a.localeCompare(b)) as string[]
      )
    ];
    this.arrayServices = uniqueBy(sortedBiblia, 'dayName');
    this.arrayNombreFile = uniqueBy(sortedBiblia, 'nombreItinerario');
    this.arrayDates = uniqueBy(sortedBiblia, 'date');
    this.arrayUsers = uniqueBy(sortedBiblia, 'usuario');
    this.arrayAgencia = uniqueBy(sortedBiblia, 'agencia');
    this.arrayStatus = uniqueBy(sortedBiblia, 'fileDisplayState');

    this.arrayTipoSalida = ['Privado', 'Serie', 'Salida Fija'];
    this.arrayTypesOfService = [...new Set(typesServices)];
    this.arrayProveedor = [...new Set(typesProviders)];

    this.servicesBibliaService.saveDataBliblia$(sortedBiblia);

    this.cdRef.detectChanges();
    this.applyFilterSelect();
    this.isLoadingBiblia = false;
    this.loading = false;
  }

  pageSize: number = 10;
  currentPage = 0;
  totalItems: number = 0;

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.applyFilterSelect();
  }

  /**
   * Applies all active filters (search terms, dropdown selections, date range)
   * to the underlying data model to produce the filtered list.
   * Also applies sorting logic, including custom cascade sorting for 'date', 'day',
   * and 'horaProgramada' columns, maintaining chronological ordering and grouping by file.
   *
   * @returns {void}
   */
  matchesFilter(activityBibliaItem: any, excludeFilter?: string): boolean {
    const terms = this.searchValue?.trim()
      ? this.searchValue
          .toLowerCase()
          .split(' ')
          .filter((t) => t)
      : null;

    const hasDateFilter = !!(this.startDateFile && this.endDateFile);
    const startDateStr = hasDateFilter
      ? moment(this.startDateFile).format('YYYY-MM-DD')
      : null;
    const endDateStr = hasDateFilter
      ? moment(this.endDateFile).format('YYYY-MM-DD')
      : null;

    const selectReview = this.selectReview?.toUpperCase() || null;

    const selectDestinoValue = this.selectDestino?.value!;
    const normalizedDestinos =
      selectDestinoValue?.length > 0
        ? new Set(selectDestinoValue.map((d: string) => d.trim().toLowerCase()))
        : null;

    // 1. Check exact matches
    if (excludeFilter !== 'nombreFile') {
      if (
        this.selectNombreServicio &&
        activityBibliaItem.nombreItinerario !== this.selectNombreServicio
      )
        return false;
    }
    if (excludeFilter !== 'file') {
      if (this.selectFile) {
        const target = this.selectFile.trim().toLowerCase();
        const fileNum =
          this.getFileNumberAndExtension(activityBibliaItem).toLowerCase();
        const filePadre = (
          activityBibliaItem.fileNumberPadre || ''
        ).toLowerCase();
        const matchesFile =
          fileNum.includes(target) || filePadre.includes(target);
        if (!matchesFile) return false;
      }
    }
    if (excludeFilter !== 'destino') {
      if (normalizedDestinos) {
        const itemDestino = activityBibliaItem?.destino?.trim().toLowerCase();
        if (!itemDestino || !normalizedDestinos.has(itemDestino)) return false;
      }
    }
    if (excludeFilter !== 'status') {
      if (
        this.selectStatus &&
        activityBibliaItem.fileDisplayState !== this.selectStatus
      )
        return false;
    }
    if (excludeFilter !== 'review') {
      if (selectReview) {
        const status = selectReview.toLowerCase();
        if (status === 'aprobado') {
          if (activityBibliaItem.pendingCsReviews !== false) return false;
        } else if (status === 'pendiente') {
          if (activityBibliaItem.pendingCsReviews !== true) return false;
        } else if (status === 'sin revisión') {
          if (activityBibliaItem.pendingCsReviews != null) return false;
        }
      }
    }
    if (excludeFilter !== 'tipoSalida') {
      if (this.selectTipoSalida) {
        const tipoSalida = activityBibliaItem.tipoSalida;
        const matchesTipoSalida = Array.isArray(tipoSalida)
          ? tipoSalida.includes(this.selectTipoSalida)
          : tipoSalida === this.selectTipoSalida;

        if (!matchesTipoSalida) return false;
      }
    }

    if (
      this.typeOfServiceSelected &&
      !(activityBibliaItem.lstServicios || []).some(
        (s: any) => s.tipoServicio === this.typeOfServiceSelected
      )
    ) {
      return false;
    }
    if (
      this.selectProvider &&
      !(activityBibliaItem.lstServicios || []).some(
        (s: any) => s.objProvider?.nombre === this.selectProvider
      )
    ) {
      return false;
    }

    // Date range
    if (hasDateFilter) {
      let matchesStartDateFile = false;
      if (activityBibliaItem.startDateFile) {
        const dateOnly = activityBibliaItem.startDateFile.split('T')[0];
        matchesStartDateFile =
          dateOnly >= startDateStr! && dateOnly <= endDateStr!;
      }
      if (!matchesStartDateFile) return false;
    }

    if (this.startDateActivity && this.endDateActivity) {
      const activityStart = moment(this.startDateActivity).format('YYYY-MM-DD');
      const activityEnd = moment(this.endDateActivity).format('YYYY-MM-DD');
      let matchesActivityDate = false;
      if (activityBibliaItem.date) {
        const parts = activityBibliaItem.date.includes('-')
          ? activityBibliaItem.date.split('-')
          : activityBibliaItem.date.split('/');
        if (parts.length === 3) {
          let dateOnly = '';
          if (parts[0].length === 4) {
            dateOnly = `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
          } else {
            dateOnly = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
          }
          matchesActivityDate =
            dateOnly >= activityStart && dateOnly <= activityEnd;
        }
      } else if (activityBibliaItem.dateBiblia) {
        const dateOnly = String(activityBibliaItem.dateBiblia).split('T')[0];
        matchesActivityDate =
          dateOnly >= activityStart && dateOnly <= activityEnd;
      }
      if (!matchesActivityDate) return false;
    }

    // Heavy search terms
    if (terms) {
      const searchableText = [
        activityBibliaItem.dayName,
        `${activityBibliaItem.fileNumber}${activityBibliaItem?.fileExtend || ''}`,
        ...(activityBibliaItem.lstServicios || []).map(
          (s: any) => `${s.nombreServicio || ''} ${s.objProvider?.nombre || ''}`
        ),
        activityBibliaItem.nombreItinerario,
        activityBibliaItem.fileDisplayState,
        activityBibliaItem.day,
        activityBibliaItem.date,
        activityBibliaItem.horaProgramada,
        ...(activityBibliaItem.vuelos || []).map(
          (vuelo: any) =>
            `${vuelo.airline || ''} ${vuelo.flightNumber || ''} ${vuelo.flightCode || ''} ${vuelo.flightDate || ''} ${this.formatHoraVuelo(vuelo?.departureTime) || ''} ${this.formatHoraVuelo(vuelo?.arrivalTime) || ''}`
        ),
        ...(activityBibliaItem.serviciosMedio || []).map(
          (sm: any) =>
            `${sm.circuitoTren || ''} ${sm.varianteFrecuencia || ''} ${this.convertirHora12Horas(sm?.horario || '') || ''}`
        ),
        ...(activityBibliaItem.serviciosAlojamiento || []).map(
          (s: any) =>
            `${s.paxAlojamiento || ''} ${s.tipoTarifaAlojamiento || ''}`
        ),
        ...(activityBibliaItem.equipo || []).map(
          (file: any) => file?.toString() || ''
        ),
        Array.isArray(activityBibliaItem.tipoSalida)
          ? activityBibliaItem.tipoSalida.join(' ')
          : `${activityBibliaItem.tipoSalida || ''} ${activityBibliaItem?.fileNumberPadre || ''}`,
        activityBibliaItem.paxCount,
        activityBibliaItem.tcCount,
        activityBibliaItem.agencia,
        this.getPickUp(activityBibliaItem),
        this.getDropOff(activityBibliaItem),
        ...(activityBibliaItem.serviciosCoordinador || []).map(
          (s: any) => s.objProvider?.nombre || ''
        ),
        ...(activityBibliaItem.serviciosTransporte || []).map(
          (s: any) =>
            `${s.objProvider?.nombre || ''} ${s.categoriaServicio || ''} ${s.tipoDeUnidad || ''}`
        ),
        activityBibliaItem?.driver || '',
        ...(activityBibliaItem.serviciosMeals || []).map(
          (s: any) => `${s.nombreServicio || ''} ${s.objProvider?.nombre || ''}`
        ),
        ...(activityBibliaItem.serviciosSnacks || []).map(
          (s: any) => s.nombreServicio || ''
        ),
        ...(activityBibliaItem.lstPaXByActivity || []).map(
          (pax: any) =>
            `${pax?.pasajero?.firstName || ''} ${pax?.pasajero?.lastName || ''} ${pax?.Pax || ''} ${pax?.pasajero?.restriccionesAlimentarias || ''} ${pax?.pasajero?.condicionesMedicas || ''} ${pax?.pasajero?.alergias || ''}`
        ),
        activityBibliaItem.obsActivity,
        activityBibliaItem.destino,
        activityBibliaItem.usuario,
        activityBibliaItem.usuarioOperador,
        activityBibliaItem.dateActualizacion
      ]
        .join(' ')
        .toLowerCase();

      if (!terms.every((term: string) => searchableText.includes(term))) {
        return false;
      }
    }

    // Presets A.C.
    if (this.activePreset) {
      if (this.activePreset === 'today') {
        const todayStr = moment().format('YYYY-MM-DD');
        if (activityBibliaItem.date) {
          const parts = activityBibliaItem.date.split('-');
          if (parts.length === 3) {
            const dateOnly = `${parts[2]}-${parts[1]}-${parts[0]}`;
            if (dateOnly !== todayStr) return false;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else if (this.activePreset === 'next3days') {
        const todayStr = moment().format('YYYY-MM-DD');
        const next3Str = moment().add(3, 'days').format('YYYY-MM-DD');
        if (activityBibliaItem.date) {
          const parts = activityBibliaItem.date.split('-');
          if (parts.length === 3) {
            const dateOnly = `${parts[2]}-${parts[1]}-${parts[0]}`;
            if (dateOnly < todayStr || dateOnly > next3Str) return false;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else if (this.activePreset === 'pendingAC') {
        if (activityBibliaItem.pendingCsReviews !== true) return false;
      } else if (this.activePreset === 'minors') {
        if (
          !activityBibliaItem.lstPaXByActivity ||
          !this.hasMinors(activityBibliaItem.lstPaXByActivity)
        ) {
          return false;
        }
      }
    }

    return true;
  }

  updateFilterOptions() {
    if (!this.model) return;

    const uniqueBy = (arr: any[], prop: string) =>
      [
        ...new Set(
          arr
            .map((item: any) => item[prop])
            .filter(
              (val: any) => val !== null && val !== undefined && val !== ''
            )
            .sort((a: any, b: any) => {
              if (typeof a === 'string' && typeof b === 'string') {
                return a.localeCompare(b);
              }
              return String(a).localeCompare(String(b));
            })
        )
      ] as any[];

    // 1. Files filter options:
    this.arrayFiles = [
      ...new Set(
        this.bibliaFilesCache
          .map((fileItem: any) => this.getFileNumberAndExtension(fileItem))
          .filter(Boolean)
          .sort((a: any, b: any) => b.localeCompare(a))
      )
    ] as string[];

    // 2. Nombre de File options:
    const nombreFiltered = this.model.filter((item: any) =>
      this.matchesFilter(item, 'nombreFile')
    );
    this.arrayNombreFile = uniqueBy(nombreFiltered, 'nombreItinerario');

    // 3. Destino options:
    const destinoFiltered = this.model.filter((item: any) =>
      this.matchesFilter(item, 'destino')
    );
    this.arrayDestino = [
      ...new Set(
        destinoFiltered
          .map((item: any) => item?.destino?.toUpperCase())
          .filter(Boolean)
          .sort((a: any, b: any) => a.localeCompare(b)) as string[]
      )
    ];

    // 4. Status options:
    const statusFiltered = this.model.filter((item: any) =>
      this.matchesFilter(item, 'status')
    );
    this.arrayStatus = uniqueBy(statusFiltered, 'fileDisplayState');

    // 5. Review options:
    const reviewFiltered = this.model.filter((item: any) =>
      this.matchesFilter(item, 'review')
    );
    const reviewOptions = new Set<string>();
    reviewFiltered.forEach((item: any) => {
      if (item.pendingCsReviews === false) {
        reviewOptions.add('Aprobado');
      } else if (item.pendingCsReviews === true) {
        reviewOptions.add('Pendiente');
      } else {
        reviewOptions.add('Sin revisión');
      }
    });
    this.arrayReviewAC = Array.from(reviewOptions).sort();

    // 6. Tipo Salida options:
    const tipoSalidaFiltered = this.model.filter((item: any) =>
      this.matchesFilter(item, 'tipoSalida')
    );
    const tipoSalidaOptions = new Set<string>();
    tipoSalidaFiltered.forEach((item: any) => {
      const ts = item.tipoSalida;
      if (Array.isArray(ts)) {
        ts.forEach((t: any) => {
          if (t) tipoSalidaOptions.add(t);
        });
      } else if (ts) {
        tipoSalidaOptions.add(ts);
      }
    });
    this.arrayTipoSalida = Array.from(tipoSalidaOptions).sort();
  }

  /**
   * Applies all active filters (search terms, dropdown selections, date range)
   * to the underlying data model to produce the filtered list.
   * Also applies sorting logic, including custom cascade sorting for 'date', 'day',
   * and 'horaProgramada' columns, maintaining chronological ordering and grouping by file.
   *
   * @returns {void}
   */
  applyFilterSelect() {
    if (!this.model) return;
    let filteredBiblia = this.model.filter((item: any) =>
      this.matchesFilter(item)
    );

    // Sort filteredBiblia based on active sort header or fallback to default
    const sortField = this.activeSortField;
    const sortDir = this.activeSortDirection;
    if (sortField && sortDir) {
      const isAsc = sortDir === 'asc';
      const field = sortField as string;
      filteredBiblia.sort((a: any, b: any) => {
        let comparison = 0;
        if (field === 'day' || field === 'horaProgramada') {
          // Cascade sorting: Group by fileNumber + fileExtend, then by date, then by horaProgramada, then by dayInItinerary
          const fileA = `${a.fileNumber || ''}${a.fileExtend || ''}`;
          const fileB = `${b.fileNumber || ''}${b.fileExtend || ''}`;
          if (fileA !== fileB) {
            return isAsc
              ? fileA.localeCompare(fileB)
              : fileB.localeCompare(fileA);
          }

          const dateA = this._parseDateDDMMYYYY(a.date);
          const dateB = this._parseDateDDMMYYYY(b.date);
          if (dateA !== dateB) {
            return isAsc ? dateA - dateB : dateB - dateA;
          }

          const horaA = a.horaProgramada;
          const horaB = b.horaProgramada;
          let cmpHora = 0;
          if (horaA && horaB) {
            cmpHora = this._compareHoraProgramada(horaA, horaB);
          } else if (horaA) {
            cmpHora = -1;
          } else if (horaB) {
            cmpHora = 1;
          }

          if (cmpHora !== 0) {
            return isAsc ? cmpHora : -cmpHora;
          }

          const cmpSubday = this._compareDayInItinerary(
            a.dayInItinerary,
            b.dayInItinerary
          );
          return isAsc ? cmpSubday : -cmpSubday;
        } else if (field === 'date') {
          const dateA = this._parseDateDDMMYYYY(a.date);
          const dateB = this._parseDateDDMMYYYY(b.date);
          if (dateA !== dateB) {
            return isAsc ? dateA - dateB : dateB - dateA;
          }
          return this._defaultBibliaSort(a, b);
        } else {
          const valA = a[field];
          const valB = b[field];
          if (valA !== undefined && valB !== undefined) {
            if (typeof valA === 'string') {
              comparison = valA.localeCompare(valB);
            } else {
              comparison = valA - valB;
            }
          }
          if (comparison === 0) {
            return this._defaultBibliaSort(a, b);
          }
          return isAsc ? comparison : -comparison;
        }
      });
    } else {
      filteredBiblia.sort((a: any, b: any) => this._defaultBibliaSort(a, b));
    }

    this.totalItems = filteredBiblia?.length;

    if (
      this.totalItems > 0 &&
      this.currentPage * this.pageSize >= this.totalItems
    ) {
      this.currentPage = Math.max(
        0,
        Math.ceil(this.totalItems / this.pageSize) - 1
      );
      if (this.paginator) {
        this.paginator.pageIndex = this.currentPage;
      }
    } else if (this.totalItems === 0) {
      this.currentPage = 0;
      if (this.paginator) {
        this.paginator.pageIndex = 0;
      }
    }

    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;

    this.bibliaDataSource.data = filteredBiblia.slice(start, end);
    if (this.paginator) {
      this.paginator.length = this.totalItems;
    }

    this.updateFilterOptions();
    setTimeout(() => {
      if (this.table) {
        this.table.updateStickyColumnStyles();
      }
    }, 50);
  }

  allExpanded = false; // Estado global de expansión
  toggleAllRows(): void {
    this.allExpanded = !this.allExpanded; // Alterna el estado global

    // Aplica el estado a todas las filas
    this.bibliaDataSource.data.forEach((row: any) => {
      row['expanded'] = this.allExpanded;
    });
  }

  isValidDate(value: any): boolean {
    if (!value || value === 'null' || value === '') {
      return false;
    }
    const date = new Date(value);
    return !isNaN(date.getTime()); // Verifica si es una fecha válida
  }

  // Método individual para alternar una fila específica
  toggleRow(row: any): void {
    row.expanded = !row.expanded;
  }

  addDaysToDate(date: any, days: any): any {
    const res = new Date(date);
    res.setDate(res.getDate() + days);
    return res;
  }

  transformDate(date: String, day: String) {
    const days = date.split('/')[0];
    const months = date.split('/')[1];
    const year = date.split('/')[2];

    const tmpDate = new Date(Number(year), Number(months), Number(days));
    const dateRpst = new Date(
      this.addDaysToDate(tmpDate, Number(Number(day) - 1))
    );
    const options: any = { year: 'numeric', month: 'numeric', day: 'numeric' };
    const formattedDate = dateRpst.toLocaleDateString(options);
    return formattedDate;
  }

  showDateNum(date: String, day: String) {
    const days = date.split('/')[0];
    const months = date.split('/')[1];
    const year = date.split('/')[2];

    var tmpDate = new Date(Number(year), Number(months), Number(days));
    const dateRpst = new Date(
      this.addDaysToDate(tmpDate, Number(Number(day) - 1))
    );
    return Date.UTC(Number(year), Number(months), Number(days));
  }

  convertirHora12Horas(fechaString: string): string {
    const fecha = new Date(fechaString);

    let horas = fecha.getHours();
    const minutos = fecha.getUTCMinutes();
    const ampm = horas >= 12 ? 'PM' : 'AM';

    horas = horas % 12 || 12;
    const horaFormateada = `${horas}:${minutos
      .toString()
      .padStart(2, '0')} ${ampm}`;
    return horaFormateada;
  }

  formatHoraVuelo(hora: string): string {
    if (!hora || hora === 'null') {
      return 'N/A';
    }
    // Si el formato ya es "HH:mm:ss", moment lo parsea directamente
    return moment(hora, 'HH:mm:ss').format('HH:mm');
  }

  openDialogPasajeros(lstPaX: any): void {
    const dialogRef = this.dialog.open(PasajerosDialogComponent, {
      width: '1200px',
      height: '600px',
      data: lstPaX
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('openPasajerosDialog closed', result);
    });
  }

  onGo(i: string) {
    //onGo(model: fileModel) {
    //this.router.navigate(['/incidencia', model.id], { state: model.services });
    this.router.navigate(['/incidencia', i]);
  }

  private _getDateTransformDate(date: string) {
    const dateSeparated = date.slice(0, 10).split('-');

    const year = dateSeparated[0];
    const month = dateSeparated[1];
    const day = dateSeparated[2];

    return `${day}-${month}-${year}`;
  }

  private _parseDateDDMMYYYY(dateStr: string): number {
    if (!dateStr) return 0;
    const parts = dateStr.split('-');
    if (parts.length !== 3) return 0;
    return new Date(
      Number(parts[2]),
      Number(parts[1]) - 1,
      Number(parts[0])
    ).getTime();
  }

  isPassengerMinor(pax: any): boolean {
    const age = pax?.pasajero?.age;
    if (age === null || age === undefined || age === '') return false;
    const numAge = Number(age);
    return !isNaN(numAge) && numAge < 18;
  }

  hasMinors(lstPaX: any[]): boolean {
    if (!lstPaX || !Array.isArray(lstPaX)) return false;
    for (const pasajeros of lstPaX) {
      if (this.isPassengerMinor(pasajeros)) {
        return true;
      }
    }
    return false;
  }

  getPassengerDisplayName(pax: any): string {
    const firstName = pax?.pasajero?.firstName?.trim();
    const lastName = pax?.pasajero?.lastName?.trim();

    if (firstName || lastName) {
      return [firstName, lastName].filter(Boolean).join(' ');
    }

    return pax?.Pax || 'N/A';
  }

  isPassengerTC(pax: any): boolean {
    return !!(
      pax?.isTC ||
      (pax?.Pax &&
        typeof pax.Pax === 'string' &&
        pax.Pax.toLowerCase().includes('tc-')) ||
      pax?.tipoPasajero === 'TC'
    );
  }

  getSortedPaxList(lstPaX: any[]): any[] {
    if (!lstPaX || !Array.isArray(lstPaX)) return [];
    return [...lstPaX].sort((a, b) => {
      const aIsTc = this.isPassengerTC(a);
      const bIsTc = this.isPassengerTC(b);
      if (aIsTc && !bIsTc) return -1;
      if (!aIsTc && bIsTc) return 1;
      const nameA = (this.getPassengerDisplayName(a) || '').toLowerCase();
      const nameB = (this.getPassengerDisplayName(b) || '').toLowerCase();
      return nameA.localeCompare(nameB, 'es', { sensitivity: 'base' });
    });
  }

  formatPassengerName(pax: any): string {
    const name = this.getPassengerDisplayName(pax);
    if (!name || name === 'N/A') return 'N/A';
    if (name === name.toUpperCase()) {
      return name
        .toLowerCase()
        .split(' ')
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
    }
    return name;
  }

  cleanMedicalOrDietaryText(text: string): string {
    if (!text || typeof text !== 'string') return '';
    let cleaned = text.trim();
    cleaned = cleaned.replace(/^[>\-,\s:;]+/, '').trim();
    return cleaned;
  }

  getPaxConditionsList(
    lstPaX: any[],
    field: 'restriccionesAlimentarias' | 'condicionesMedicas' | 'alergias'
  ): Array<{ pax: any; name: string; detail: string; isTC: boolean }> {
    if (!lstPaX || !Array.isArray(lstPaX)) return [];
    const invalidValues = [
      'ninguna',
      'ninguno',
      'ningun',
      'none',
      '-',
      'no',
      'sin restricciones',
      'sin alergias',
      'sin condiciones',
      'n/a'
    ];
    const validItems: Array<{
      pax: any;
      name: string;
      detail: string;
      isTC: boolean;
    }> = [];

    for (const p of lstPaX) {
      const raw = p?.pasajero?.[field];
      if (raw && typeof raw === 'string') {
        const cleaned = this.cleanMedicalOrDietaryText(raw);
        if (cleaned && !invalidValues.includes(cleaned.toLowerCase())) {
          validItems.push({
            pax: p,
            name: this.formatPassengerName(p),
            detail: cleaned,
            isTC: this.isPassengerTC(p)
          });
        }
      }
    }

    return validItems.sort((a, b) =>
      a.name.localeCompare(b.name, 'es', { sensitivity: 'base' })
    );
  }

  // getPassengerPhone(pax: any): string {
  //   if (
  //     pax?.pasajero?.phone === 'undefined' ||
  //     pax?.pasajero?.phone == null ||
  //     pax?.pasajero?.phone.trim() === ''
  //   ) {
  //     return '';
  //   }
  //   return pax?.pasajero?.phone?.trim();
  // }

  transform(data: any) {
    return JSON.stringify(data);
  }

  transformLstPaxToExport(lstPax: BibliaItemModel['lstPaX']) {
    if (lstPax == null || lstPax?.length === 0) {
      return '';
    }
    return (
      lstPax
        .map((pax) => {
          const passengerName = this.getPassengerDisplayName(pax);
          // const passengerPhone = this.getPassengerPhone(pax);

          return passengerName;
        })
        // .map(pax => {
        // const fullName =
        //   `${pax?.pasajero?.firstName || ''} ${
        //     pax?.pasajero?.lastName || ''
        //   }` || 'N/A'
        // const lastName = pax.pasajero?.lastName || ''
        // const age = pax.pasajero?.age || 'N/A'
        // const gender = pax.pasajero?.gender ? ` (${pax.pasajero.gender})` : ''
        // const medicalConditions = pax.pasajero?.condicionesMedicas
        //   ? ` [${pax.pasajero.condicionesMedicas}]`
        //   : ''

        // return fullName.trim()
        // })
        .join(', ')
    );
  }

  transformUpperCase(data: string | null) {
    return data?.toUpperCase() || '';
  }

  onApplyRangeSelected() {
    this.startDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.startDate))
    );
    this.endDateSelected = this.getDateTransform(
      JSON.stringify(new Date(this.endDate))
    );

    this.applyFilterSelect();
  }

  onApplyRangeSelectedFile() {
    if (this.startDateFile && this.endDateFile) {
      this.startDateFileSelected = new Date(this.startDateFile).toISOString();
      this.endDateFileSelected = new Date(this.endDateFile).toISOString();
      // this.loadDataBiblia(this.startDateFileSelected, this.endDateFileSelected);
    }
  }

  applyFilterHora() {
    this.startHourSelected = this.startTime;
    this.endHourSelected = this.endTime;
    this.applyFilterSelect();
  }

  cleanTime() {
    this.startTime = null;
    this.endTime = null;
    this.applyFilterHora();
  }

  getDateTransform(date: string) {
    const dateSeparated = date.slice(1, 11).split('-');
    const month = dateSeparated[1];
    const day = dateSeparated[2];
    const year = dateSeparated[0];
    return `${month}/${day}/${year}`;
  }

  cleanDateSelected() {
    this.startDate = null;
    this.startDateSelected = null;
    this.endDate = null;
    this.endDateSelected = null;

    this.applyFilterSelect();
  }

  cleanDateSelectedFile() {
    this.startDateFile = null;
    this.startDateFileSelected = null;
    this.endDateFile = null;
    this.endDateFileSelected = null;

    this.applyFilterSelect();
  }

  cleanDateSelectedActivity() {
    this.startDateActivity = null;
    this.endDateActivity = null;
    this.applyFilterSelect();
  }

  openDialogListServices(
    activity: any,
    actionType: keyof typeof BIBLIA_ACTIONS
  ) {
    let dialogConfig = new MatDialogConfig();
    // console.log({ model: activity, type: actionType })
    dialogConfig.data = {
      activity,
      type: actionType
    };

    // dialogConfig.width = "100%";
    dialogConfig.height = '600px';
    dialogConfig.width = '1100px';

    let dialogRef = this.dialog.open(
      DialogServiciosListComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.event === 'add') {
        this.ngOnInit();
      }
    });
  }

  openDialogListhistorial(model: any, type: String) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      data: model,
      type: type
    };

    dialogConfig.width = '100%';
    dialogConfig.height = '70%';
    dialogConfig.maxWidth = '800px';

    let dialogRef = this.dialog.open(
      DialogServiceHistorialComponent,
      dialogConfig
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.event === 'add') {
        // this.addIncidenciaToService(result, model.fileNumber, model.itineraryId);
        this.ngOnInit();
      }
    });
  }

  openDialogCsReview(bibliaItem: any): void {
    let dialogConfig = new MatDialogConfig();
    console.log({ bibliaItem });

    dialogConfig.disableClose = true;
    dialogConfig.data = {
      itineraryId: bibliaItem.idItinerary,
      activityId: bibliaItem.idActivity,
      activityDay: bibliaItem.day,
      destination: bibliaItem.dayDestino || bibliaItem.destino,
      activityName: bibliaItem.dayName
    };

    let dialogRef = this.dialog.open(DialogRevisionACComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      console.log({ Biblia_result: result });
      if (typeof result === 'number') {
        bibliaItem.pendingCsReviews = result > 0;
      } else {
        bibliaItem.pendingCsReviews = null;
      }
    });
  }

  /**
   * Modal para editar los campos `pickUp`, `dropOff` y `driver` de una actividad.
   * Driver: Contiene el nombre y contacto del conductor asignado para los pasajeros. Este conductor debe ser para pasajeros, no se consideran conductores para otros servicios que no sean PAX.
   * @param activityProperty Propiedad de la actividad que se va a editar, solo puede ser `pickUp`, `dropOff` o `driver`.
   * @param newValue Nuevo valor que se le asignará a la propiedad editada, se muestra como valor inicial dentro del modal.
   * @param bibliaActivityItem Actividad de la biblia que se va a editar, se utiliza para mostrar información relevante dentro del modal y para actualizar el valor en la tabla después de editarlo.

   * @returns
   */
  openDialogEdit(
    activityProperty: 'pickUp' | 'dropOff' | 'driver',
    newValue: string,
    bibliaActivityItem: BibliaItemModel
  ) {
    let dialogConfig = new MatDialogConfig();

    // Validaciones
    if (
      activityProperty === 'driver' &&
      bibliaActivityItem.serviciosTransporte?.length === 0
    ) {
      console.warn(
        `No se encontraron actividades para el itineraryId ${bibliaActivityItem.idItinerary}`
      );
      Swal.fire({
        position: 'top-end',
        icon: 'warning',
        title: 'No se encontró transportes',
        text: 'Esta actividad no tiene servicios de transporte asociados para asignar un conductor.',
        showConfirmButton: false,
        timer: 3000
      });
      return;
    }

    dialogConfig.data = {
      prop: activityProperty,
      value: newValue,
      data: bibliaActivityItem
    };

    dialogConfig.width = '420px';
    dialogConfig.maxWidth = '92vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.disableClose = true;
    let dialogRef = this.dialog.open(DialogEditComponent, dialogConfig);

    const dialogInstance = dialogRef.componentInstance;
    const saveSubscription = dialogInstance.saveRequested.subscribe(
      (payload: DialogEditSavePayload) => {
        const { prop, value } = payload;

        this.updateActivityProperty({
          prop,
          value,
          itineraryId: bibliaActivityItem.idItinerary,
          activityId: bibliaActivityItem.idActivity,
          numberFile: bibliaActivityItem.fileNumber,
          day: bibliaActivityItem.day,
          dialogRef
        });
      }
    );

    dialogRef.afterClosed().subscribe(() => saveSubscription.unsubscribe());
  }

  openTimePickerDialog(element: any): void {
    const dialogRef = this.dialog.open(TimePickerDialogComponent, {
      width: '400px',
      data: { element }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result.success === true) {
          element.horaProgramada = result.horaProgramada;
          this.applyFilterSelect();
        }
      }
    });
  }

  updateActivityProperty({
    prop,
    value,
    itineraryId,
    activityId,
    numberFile,
    day,
    dialogRef
  }: {
    prop: 'pickUp' | 'dropOff' | 'driver' | 'horaInicioOperacion';
    value: any;
    activityId: string;
    day: number;
    numberFile: string;
    itineraryId: string;
    dialogRef?: MatDialogRef<DialogEditComponent>;
  }) {
    let targetActivities = [{ activityId, day: day }];

    if (prop === 'driver') {
      const itineraryActivitiesToUpdate = this.model.filter(
        (bibliaActivityRow: any) =>
          bibliaActivityRow.idItinerary === itineraryId
      );
      const validActivitiesToUpdate = itineraryActivitiesToUpdate.filter(
        (bibliaActivityRow: any) =>
          bibliaActivityRow?.driver == null &&
          bibliaActivityRow.serviciosTransporte?.filter(
            (transport: any) =>
              transport.categoriaServicio === 'TRANSPORTEPAX' &&
              !transport.objProvider?.nombre?.includes('EXPLORANDES')
          )?.length > 0
      );

      validActivitiesToUpdate.forEach((a: any) => {
        const aId = a.idActivity;
        const aDay = a.day || a.dayNumber;
        if (aId && !targetActivities.some((ta) => ta.activityId === aId)) {
          targetActivities.push({ activityId: aId, day: aDay });
        }
      });
    }

    this.fileService
      .getItineraryActivities(itineraryId)
      .pipe(
        switchMap(async (dataDetailsFiles: any) => {
          const activities = dataDetailsFiles.getItineraryActivities;

          const updatePromises = targetActivities.map((ta) => {
            const updatedActivity = activities.find((activity: any) => {
              return (
                activity.dayNumber === Number(ta.day) &&
                activity.id === ta.activityId
              );
            });

            if (!updatedActivity) return Promise.resolve(null);

            updatedActivity[prop] = value;
            updatedActivity.dateActualizacion = new Date();
            updatedActivity.usuarioOperador = this.userName;

            return firstValueFrom(
              this.fileService.updateActivity(updatedActivity)
            );
          });

          await Promise.all(updatePromises);
          return true;
        })
      )
      .subscribe({
        next: (value) => {
          console.log('Actividad actualizada correctamente:', value);
        },
        error: (error) => {
          console.warn('Error al actualizar la actividad:', error);
          const errorMessage =
            'No se pudo guardar el cambio. Verifica tu conexión e inténtalo de nuevo.';

          if (dialogRef) {
            dialogRef.componentInstance.showError(errorMessage);
            return;
          }

          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Ocurrió un error',
            text: errorMessage,
            showConfirmButton: false,
            timer: 3000
          });
        },
        complete: () => {
          this.model = this.servicesBibliaService.updateProperties(
            prop,
            value,
            targetActivities,
            numberFile,
            itineraryId,
            this.userName
          );

          if (dialogRef) {
            dialogRef.close({
              event: 'add',
              data: { prop, value }
            });
          }

          let baseTitle = 'Se editó el campo correctamente';
          let htmlContent = '';
          let timerVal = 3000;

          if (targetActivities.length > 1) {
            baseTitle = 'Se actualizaron múltiples actividades';
            const daysHtml = targetActivities
              .sort((a, b) => Number(a.day) - Number(b.day))
              .map(
                (ta) =>
                  `<span style="display: inline-block; padding: 4px 8px; margin: 2px; background: #e0f2f1; color: #00695c; border-radius: 4px; font-weight: bold; font-size: 0.9em;">Día ${ta.day}</span>`
              )
              .join('');
            htmlContent = `<div style="margin-top: 10px;">Actividades modificadas:</div><div style="margin-top: 8px; display: flex; flex-wrap: wrap; justify-content: center;">${daysHtml}</div>`;
            timerVal = 5000;
          }

          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: baseTitle,
            html: htmlContent || undefined,
            showConfirmButton: false,
            timer: timerVal
          });

          this.applyFilterSelect();
        }
      });
  }

  // validar que si en servicios ticket
  getRowClass(row: any): string {
    if (row.pendingCsReviews) {
      return 'regular-row';
    } else if (row.hasUpgradeService) {
      return 'upgrade-row';
    }
    return '';
  }

  getPickUp(row: BibliaItemModel): string {
    if (row?.pickUp) {
      return row.pickUp;
    }

    if (
      row?.serviciosAlojamiento != null &&
      row.serviciosAlojamiento?.length > 0
    ) {
      return row.serviciosAlojamiento
        .map((alojamiento) => {
          const nombre = alojamiento.objProvider?.nombre;
          const reserva = alojamiento.numReserva;
          if (nombre) {
            return `${nombre}${reserva ? ` - ${reserva}` : ''}`;
          }
          return null;
        })
        .filter(Boolean)
        .join(', \n');
    }

    return 'Sin Alojamiento';
  }

  getDropOff(row: BibliaItemModel): string {
    if (row?.dropOff) {
      return row.dropOff;
    }

    if (
      row?.serviciosAlojamiento != null &&
      row.serviciosAlojamiento?.length > 0
    ) {
      return row.serviciosAlojamiento
        .map((alojamiento) => {
          const nombre = alojamiento.objProvider?.nombre;
          const reserva = alojamiento.numReserva;

          if (nombre) {
            return `${nombre}${reserva ? ` - ${reserva}` : ''}`;
          }
          return null;
        })
        .filter(Boolean)
        .join(', \n');
    }

    return 'Sin Alojamiento';
  }

  getFormattedRestriccionesAlimentarias(
    lstPaX: BibliaItemModel['lstPaX']
  ): string {
    if (!lstPaX || lstPaX?.length === 0) {
      return '';
    }

    return lstPaX
      .filter((pax) => pax?.pasajero?.restriccionesAlimentarias)
      .map(
        (pax) =>
          `${pax.pasajero?.firstName} ${pax.pasajero?.lastName} - ${pax.pasajero?.restriccionesAlimentarias}`
      )
      .join('; ');
  }

  getFormattedCondicionesMedicas(lstPaX: BibliaItemModel['lstPaX']) {
    if (!lstPaX || lstPaX?.length === 0) {
      return '';
    }

    return lstPaX
      .filter((pax) => pax?.pasajero?.condicionesMedicas)
      .map(
        (pax) =>
          `${pax.pasajero?.firstName} ${pax.pasajero?.lastName} - ${pax.pasajero?.condicionesMedicas}`
      )
      .join('; ');
  }

  getFormattedAlergias(lstPaX: BibliaItemModel['lstPaX']) {
    if (!lstPaX || lstPaX?.length === 0) {
      return '';
    }

    return lstPaX
      .filter((pax) => pax?.pasajero?.alergias)
      .map(
        (pax) =>
          `${pax.pasajero?.firstName} ${pax.pasajero?.lastName} - ${pax.pasajero?.alergias}`
      )
      .join('; ');
  }

  trackByActivityId(index: number, item: any): string {
    return item.idActivity || index.toString();
  }
}
